console.log(`Node Env: ${process.env.NODE_ENV}, Platform: ${process.env.REACT_APP_PLATFORM}`);
export const app = {
  // URL: 'https://dev-cf.untoxicate.com',  
  // URL:'http://localhost:3200'
  URL: process.env.REACT_APP_PLATFORM === 'production' ? process.env.REACT_APP_PRODUCTION : process.env.REACT_APP_PLATFORM === 'staging' ? process.env.REACT_APP_STAGING : 'https://api.babyreveal.com',
  // URL: 'https://websitestagging.know.us',
};
